module.exports = __webpack_public_path__ + "static/media/mobile-money.f2c45e46.png";